<div class="col-12 p-0 service-history-table desktop-view">
  <div class="position-relative" [ngClass]="{'fixedHeightScroll': !state.paginationRequired }">
  <table class="table w-100" aria-labelledby="table">
    <thead tabindex="0"  [ngClass]="{'stickyTop': !state.paginationRequired }">
      <tr>
        <th class="headerLabel" *ngIf="state.checkboxRequired">
          <mat-checkbox tabindex="0" [checked]="state.checkboxState" [disabled]="state.headerCheckboxdisabled || state.tableData.length === 0" [ngClass]="{'small-checkbox-css': isRaymondAvailableUsersTable}"
            (change)="handleHeaderCheckboxChange($event.checked)">
          </mat-checkbox>
        </th>
        <th class="headerLabel" [ngClass]="'headerLabel_'+ headerIndex" *ngFor="let header of state.headers; let headerIndex = index" tabindex="0">
          {{header.label}}
          <div class="sort-icon" *ngIf="header.sort" role="button" tabindex="0" (click)="sortColumn(header.key, headerIndex, headerSortable)"
          [ngStyle]="{ transform: headerSortable === 'asc'&& activeIndex === headerIndex  ? 'rotate(0deg)' : 'rotate(180deg)'}"
          [ngClass]="{ activeSortIcon: activeIndex === headerIndex }">
          </div>
          <div *ngIf="header.isTooltipPresent" tabindex="0" class="card-list-tooltip-desktop">
            <img matTooltipPosition="below" matTooltip={{header.tooltip?.content}} class="info-image--desktop-view"
              #tooltipdesktop="matTooltip" attr.aria-label="{{ header.tooltip?.content }}" alt="info icon"
              src="assets/card_list_tooltip_desktop.svg"
              matTooltipClass="'card-list-tooltip'"
              matTooltipPositionAtOrigin="true">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="tableRow" *ngFor="let item of (state.paginationRequired ? (state.tableData | paginate: { itemsPerPage: pager.pageSize, currentPage: pageNumber, totalItems: state.tableData.length }) : state.tableData); let itemIndex = index ">
        <td class="tableValue" *ngIf="state.checkboxRequired"> <mat-checkbox tabindex="0" [disabled]="item['disable']" [checked]="item['checked']" [ngClass]="{'small-checkbox-css': isRaymondAvailableUsersTable}"
            (change)="handleItemCheckBoxChange({itemIndex: itemIndex, checked: $event.checked, itemData: item})"></mat-checkbox>
        </td>
        <td class="tableValue" *ngFor="let header of state.headers" [ngClass]="{'pad-left': !state.checkboxRequired }">
          <ng-container *ngIf="header.key === 'status' && !isRaymond">
            <img src="/assets/status_active.svg" *ngIf="(item[header.key]==='Active') "><img src="/assets/status_inactive.svg" *ngIf="(item[header.key]==='Inactive')">
          </ng-container>
          <ng-container *ngIf="header.key === 'deleteRow' && state.deleteRowdRequired">
            <img src="assets/trash-black.svg" alt="delete icon" (click)="emitDelete(item)">
          </ng-container>
          <ng-container *ngIf="header.key === dataTableConst.location || header.key === dataTableConst.equipmentLocation; else otherFields">
            <b>{{ item['locationLabel'] }}</b>
            <div>{{ item[header.key] }}</div>
          </ng-container>
          <ng-template #otherFields>
            <div *ngIf="header.key === fieldType.subscriptionPlan" class="order-status-indicator" [ngClass]="getSubscriptionStatusClass(item[header.key])"></div>
            <span *ngIf="header.key !== fieldType.deleteRow" [ngClass]="{'fontBold':header.key===fieldType.subscriptionTerm}">{{ item[header.key]? item[header.key] : '-' }}</span>
            <div *ngIf="header.key === fieldType.subscriptionTerm" [ngClass]="{'fontRed': item['autoRenew'] === false}">{{item['renewalDateString']}}</div>
          </ng-template> 
        </td>
      </tr>
    </tbody>
    <ng-template #elseTemplate> Loading... </ng-template>
  </table>
</div>
  <div class="no-results" *ngIf="(state.tableData.length=== 0)">
    <img class="no-results-icon" src="{{noResult.icon.iconPath}}" alt="" />
    <div class="no-results-search">{{noResult.messageBold}}</div>
  </div>
  <div class="pagination-container" *ngIf="state.paginationRequired && state.tableData.length !== 0">
    <div class="show-data" tabindex="0">
      <span class="pagination-showing">Showing {{ pager.startIndex + 1 | number }}-{{ state.tableData.length >
        pager.pageSize *
        (pager.currentPage) ? pager.pageSize *
        (pager.currentPage): state.tableData.length | number }} of
        {{ state.tableData.length | number }}</span>
    </div>
    <pagination-controls role="currentpage" (pageChange)="setPage($event)" 
      aria-controls="setPage($event)"  class="pagination-bar" [maxSize]="10" nextLabel=""
      [autoHide]="true" screenReaderPaginationLabel="Pagination Navigation" previousLabel=""
      screenReaderCurrentLabel="You are on the current Page"></pagination-controls>
  </div>
</div>
<div class="kng-data-table--mobile-view">
  <div>
    <div *ngIf="state.checkboxRequired" class="selectAllParent">
      <button class="selectAll" (click)="handleHeaderCheckboxChange(!state.checkboxState)" [disabled]="state.mobileSelectAllDisable">
        {{ !state.checkboxState ? 'Select All' : 'Deselect All' }}
      </button>
    </div>
    <div class="kng-data-table--mobile-data-section" *ngFor="let item of (state.paginationRequired ? (state.tableData | paginate: { itemsPerPage: pager.pageSize, currentPage: pageNumber, totalItems: state.tableData.length }) : state.tableData); let itemIndex = index">
      <div class="kng-data-table--mobile-data-checkbox">
        <mat-checkbox *ngIf="state.checkboxRequired" tabindex="0" [disabled]="item['disable']" [checked]="item['checked']" [ngClass]="{'small-checkbox-css': isRaymondAvailableUsersTable}"
          (change)="handleItemCheckBoxChange({itemIndex: itemIndex, checked: $event.checked, itemData: item})">
        </mat-checkbox>
      </div>
      <div class="kng-data-table--mobile-data-content-row"
        *ngFor="let header of state.headers; let headerIndex = index">
        <div class="kng-data-table--mobile-data-row-item label">{{header.label}}</div>
        <div class="kng-data-table--mobile-data-row-item value" [ngClass]="{'update-css-for-name-raymond-available-users-table-mobile': isRaymondAvailableUsersTable && header.label === 'Name'}">
          <ng-container *ngIf="header.key === 'status' && !isRaymond">
            <img src="/assets/status_active.svg" *ngIf="(item[header.key]==='Active')"><img src="/assets/status_inactive.svg" *ngIf="(item[header.key]==='Inactive')">
           </ng-container>
          {{item[header.key] }}</div>
      </div>
    </div>
  </div>

  <div class="no-results"
          *ngIf="(state.tableData.length=== 0)">
          <img class="no-results-icon" src="{{noResult.icon.iconPath}}"
           alt=""/>
          <div class="no-results-search">{{noResult.messageBold}}</div>
        </div>
        <div class="pagination-container" *ngIf="state.paginationRequired && state.tableData.length !== 0">
          <div class="show-data" tabindex="0">
            <span class="pagination-showing">Showing {{ pager.startIndex + 1 | number }}-{{ state.tableData.length > pager.pageSize *
              (pager.currentPage) ? pager.pageSize *
              (pager.currentPage): state.tableData.length | number }} of
              {{ state.tableData.length | number }}</span>
          </div>
          <pagination-controls role="currentpage" (pageChange)="setPage($event)"
            aria-controls="setPage($event)"  class="pagination-bar" [maxSize]="10" nextLabel=""
            [autoHide]="true" screenReaderPaginationLabel="Pagination Navigation" previousLabel=""
            screenReaderCurrentLabel="You are on the current Page"></pagination-controls>
        </div>
</div>